/** Build a pipeline URL, optionally pre-seeding the table search via `?q=`. */
export function pipelineHref(jobId: string, searchQuery?: string | null): string {
  const base = `/jobs/${jobId}/pipeline`;
  const q = searchQuery?.trim();
  if (!q) return base;
  return `${base}?${new URLSearchParams({ q }).toString()}`;
}
